<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <div>
    <!-- fullscreen dialog for small screens -->
    <v-sheet
      v-if="!minimized && visible && $vuetify.breakpoint.xsOnly"
      color="white"
      elevation="1"
      class="small"
    >
      <p v-show="text != ''">{{ text }}</p>
      <v-progress-linear
        v-model="progress"
        height="25"
        color="orange accent-4"
      ></v-progress-linear>
    </v-sheet>

    <!-- small dialog for small screens -->
    <v-sheet
      v-if="minimized && visible && $vuetify.breakpoint.xsOnly"
      color="white"
      elevation="1"
      class="minimizedsmall"
    >
      <p v-show="text != ''">{{ text }}</p>
      <v-progress-linear
        v-model="progress"
        height="25"
        color="orange accent-4"
      ></v-progress-linear>
    </v-sheet>

    <!-- large dialog for big screen -->
    <v-dialog
      v-if="!minimized && visible && !$vuetify.breakpoint.xsOnly"
      persistent
      v-model="popup"
      width="auto "
    >
      <v-sheet
        class="dialog"
        color="white"
        elevation="1"
      >
        <p v-show="text != ''">{{ text }}</p>
        <v-progress-linear
          v-model="progress"
          height="25"
          color="orange accent-4"
        ></v-progress-linear>
      </v-sheet>
    </v-dialog>

    <!-- minimized dialog for big screen -->
    <v-sheet
      v-if="minimized && visible && !$vuetify.breakpoint.xsOnly"
      class="minimized"
      color="white"
      elevation="1"
    >
      <p v-show="text != ''">{{ text }}</p>
      <v-progress-linear
        v-model="progress"
        color="orange accent-4"
      ></v-progress-linear>
    </v-sheet>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      popup: true,
      visible: false,
      minimized: true,
      text: "",
      progress: 0,
    };
  },
  computed: {},
  watch: {},
  methods: {
    show() {
      this.minimized = false;
      this.visible = true;
      this.progress = 0;
    },
    addProgress(value, text = "") {
      this.progress += value;
      if (text) this.setText(text);
    },
    setText(text) {
      this.text = text;
    },
    hide() {
      this.visible = false;
    },
    minimize() {
      /* timeout is added to give the dialog time to setup. If an error occurs we go straight from dialog to minimized version and the dialog is not mounted yet */
      setTimeout(() => {
        this.minimized = true;
        if (this.$vuetify.breakpoint.xsOnly){
          this.hide();
        } 
      }, 200);
    },
  },
};
</script>

<style scoped>
.dialog {
  width: 400px;
  padding: 20px 30px;
}

.minimized {
  z-index: 75;
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  padding: 5px;
  width: 300px;
}

.popup p {
  text-align: center;
}

.minimized p {
  font-size: small;
  margin-bottom: 2px;
  text-align: center;
}

.small {
  z-index: 202;
  position: absolute;
  left: 0;
  right: 0;
  height: calc(100vh - 14px);
  padding: 14px;
  margin: 7px;
}

.minimizedsmall {
  z-index: 202;
  position: absolute;
  left: 0;
  right: 0;
  padding: 14px;
  margin: 7px;
}</style>